<div mat-dialog style="font-family: Roboto;">
    <mat-dialog-content>
        <h6 style="font-size: 24px;">Custom Valuation</h6>
        <div class="Vert-20"></div>
        <p *ngIf="!isCustomValuationText">This value is related to your home’s current valuation and AVM.
            <br><br>
            It was manually adjusted in HomeDashboard to reflect a {{propertyAdjustments?.adjustmentValue | number :
            '1.0-1'}} percent value change as of {{propertyAdjustments?.updatedTimestamp | date:'MM-dd-yy'}}.
            This adjustment is factored into the value you see in your dashboard and affects the equity gained.
        </p>
        <p *ngIf="isCustomValuationText">This home valuation was manually adjusted in HomeDashboard to reflect a {{propertyAdjustments?.adjustmentValue | number :
            '1.0-1'}} percent value change as of {{propertyAdjustments?.updatedTimestamp | date:'MM-dd-yy'}}. This adjustment is factored into the value you see in
            your dashboard and impacts your refinance options.
            <br><br>

            Your loan officer will be able to provide more information about opportunities for your home and how the
            home valuation affects this.
        </p>
    </mat-dialog-content>
    <mat-dialog-actions class="mb-1 float-end">
        <button mat-button (click)="dialogRef.close()">Close</button>
        <button class="btn btn-secondary" mat-button (click)="onAdjustHomeValue()">Adjust Home Value</button>
    </mat-dialog-actions>
</div>